import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as R from 'ramda';
import { uploadProfilePicture, deleteProfilePicture, getDocumentsProfile } from './../actions/user-api';
import removeAccents from 'remove-accents';
import $ from 'jquery';
import { FileTypes } from '../constants/utils/fileTypes';

export const Avatar = ({ user, profilePicture, profilePictureDocument }) => {


	const dispatch = useDispatch();
	const [file, setFile] = useState(undefined);
	const modal = useRef(null);
	const [deleteImage, setDeleteImage] = useState(false);
	const [widthIsBigger, setWidthIsBigger] = useState(false);
	const [fileName, setFileName] = useState(profilePictureDocument?.fileName);


	useEffect(() => {

		if (!R.isNil(profilePictureDocument)) {

			setFileName(profilePictureDocument.fileName);
		}


	}, [file, profilePictureDocument]);


	const hideModal = () => {
		$('.modal').modal('hide');
		setTimeout(() => {
			setDeleteImage(false);
			setFile(undefined);
		}, 300);
	};


	useEffect(() => {
		if (!R.isNil(profilePicture)) {
			let i = new Image();
			i.onload = function () {
				setWidthIsBigger(i.width > i.height);
			};
			i.src = profilePicture;
		}
	}, [profilePicture]);

	useEffect(() => {
		if (!R.isNil(file)) {
			var reader = new FileReader();

			//uploadFile
			reader.onload = async () => {
				let i = new Image();
				i.onload = function () {
					setWidthIsBigger(i.width > i.height);
				};
				i.src = reader.result;
			};
			reader.readAsDataURL(file);
		}
	}, [file]);



	return (
		<div className="modal fade px-0" data-backdrop="static" id="changeavatar" aria-labelledby="changeavatarLabel" aria-hidden="true" ref={modal}>
			<div className="modal-dialog px-2">
				<div className="modal-content">
					<header className="modal-header bg-light pb-0">
						<div className="alert bg-common rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">Avatar</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 text-primary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="addUserLabel">Modifier photo</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4 lh-root"></i>
								</button>
							</div>
						</div>
					</header>
					<div className="modal-body text-center bg-light">
						<form className="block w-100">
							<div className="form-group mb-0">
								<input id="upload-user-photo" className="d-none" type="file" accept="image/x-png,image/gif,image/jpeg" onClick={(e) => e.target.value = null} onChange={(e) => {
									const files = [...e.target.files];
									if (files.length > 0) {
										const tmpFile = files[0];
										setFile(new File([tmpFile], removeAccents(tmpFile.name).toLowerCase().replace(/\s/gi, "")));
										setDeleteImage(false);
									}
								}} />
								<div className="d-flex h-preview w-preview rounded-max bg-white thin-shadow p-1 mx-auto align-items-center justify-content-center">
									{/* <img className="img-fluid h-100 w-100" src={logo} /> */}
									{(file !== undefined || !R.isNil(profilePicture)) && deleteImage === false ? <img className={"img-fluid h-100 w-100 rounded-inherit" + (widthIsBigger ? ' img-contain' : ' img-cover')} alt="profile" src={!R.isNil(file) ? URL.createObjectURL(file) : !R.isNil(profilePicture) ? profilePicture : undefined} />
										: <i className="img-fluid eva eva-image text-muted display-4 lh-1"></i>}
									{/* show default bellow if user has no defined photo  */}
								</div>
								<label className="stretched-link mb-0" htmlFor="upload-user-photo"></label>
							</div>
						</form>
						<p className="small text-muted mb-0">Veuillez cliquer ci-dessus pour modifier votre photo de profil.<br />Vous pouvez charger un fichier jpg, gif ou png. Taille maximum du fichier: 4MB</p>
					</div>
					<div className="modal-footer justify-content-center justify-content-lg-end border-light py-3">
						<button type="button" disabled={!R.isNil(profilePicture) && profilePicture !== '' ? false : true} className={"btn bg-common text-primary btn-icon mr-lg-auto" + (!R.isNil(profilePicture) && profilePicture !== '' ? '' : ' disabled')} onClick={() => {
							if (!R.isNil(profilePicture) && profilePicture !== '' && deleteImage === false) {
								setDeleteImage(true);
								setFile(undefined);
								dispatch(deleteProfilePicture(user.id, fileName));
							}
						}}><i className="eva eva-trash-outline mr-2"></i>Supprimer <span className="ml-1"> la photo</span></button>
						<button type="button" className="btn btn-light mr-2 order-last order-md-2" data-dismiss="modal" onClick={() => hideModal()}>Annuler</button>
						<button className="btn btn-secondary order-md-last" onClick={(e) => {
							e.preventDefault();
							if (file !== undefined) {

								getDocumentsProfile(user).then((data) => {

									const profileImagesToDelete = data.filter(d => d.fileType === FileTypes.ProfilePicture && d.fileName !== file.name);
									if (!R.isEmpty(profileImagesToDelete)) {
										profileImagesToDelete.forEach(f => {

											dispatch(deleteProfilePicture(user.id, f.fileName));
										});
									}

									const reader = new FileReader();
									//uploadFile
									reader.onload = async () => {
										let blob = reader.result;
										await dispatch(uploadProfilePicture(user.id, new File([blob], removeAccents(file.name).toLowerCase().replace(/\s/gi, ""))));
										setFile(undefined);
										setFileName(file.name);
									};
									reader.readAsArrayBuffer(file);

								}).catch((error) => {
									//console.log(error);
								});


							}
							// if (deleteImage === true || profilePictureDocument) {
							// 	dispatch(deleteProfilePicture(user.id, fileName));
							// 	setDeleteImage(false);
							// }

							hideModal();
						}}>Sauvegarder</button>
					</div>
				</div>
			</div>
		</div>
	);
};